import React, { useEffect, useRef, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  InputBase,
  Box,
  Button,
  Typography,
  Divider,
  Menu,
  MenuItem,
  useMediaQuery,
  Badge,
  ToggleButton,
  ToggleButtonGroup,
  Tab,
  Tabs,
  Tooltip,
} from "@mui/material";
import {
  Notifications,
  Search,
  AccountCircle,
  Settings,
  Menu as MenuIcon,
  Home,
  Apartment,
  BedroomParent,
  Landscape,
  FilterList,
  HolidayVillage,
  Business,
  LocationCity,
  Gite,
  Store,
  Fence,
  NightShelter,
  CorporateFare,
  MapsHomeWork,
  EmojiTransportation,
  House,
  Bungalow,
  Storefront,
  AccountBalance,
  Dashboard,
  NightsStay,
  Brightness4,
  WbSunny,
  MoneyOff,
  AttachMoney,
  Lock,
  Villa,
  Tune,
  AutoAwesome,
} from "@mui/icons-material";
import { styled, alpha } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import AuthModal from "../components/modals/AuthModal";
import { useAuth } from "../context/AuthContext";
import WelcomeBackModal from "../components/modals/WelcomeBackModal";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faChevronDown,
  faChevronUp,
  faCircleArrowLeft,
  faCircleArrowRight,
  faComments,
  faHouseUser,
} from "@fortawesome/free-solid-svg-icons";
import "../styles/styles.css";
import { useProperty } from "../context/PropertyContext";
import PropertyFilterModal from "./modals/PropertyModalFilter";
import CompaniesModal from "./modals/CompaniesModal";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import LocalConvenienceStoreIcon from "@mui/icons-material/LocalConvenienceStore";
import SettingsModal from "./modals/SettingsModal";
import { useTranslation } from "react-i18next";
import { useCurrency } from "../context/CurrencyContext";
import PriceConversionModal from "./modals/PriceConversionModal";
import BrokerProfileRequiredModal from "./modals/BrokerProfileRequiredModal";
import { keyframes } from "@mui/system";
import ActiveUsers from "../utils/activeUsers";
import { usePost } from "../context/PostContext";
import { getConversationsREST } from "../services/messageService";
import { getConversationsViaHub } from "../services/signalRService";
import LogoAnimated from "./LogoAnimated";

const floatAnimation = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
  100% { transform: translateY(0); }
`;

interface IconMapping {
  [key: string]: React.ReactNode;
}

export const iconMapping: IconMapping = {
  Todas: <Dashboard />,
  Novedad: <Notifications />,
  Casa: <Home />,
  Apartamento: <Apartment />,
  Habitaciones: <BedroomParent />,
  Lote: <Landscape />,
  Condominio: <HolidayVillage />,
  Edificio: <Business />,
  Torre: <LocationCity />,
  Finca: <Gite />,
  Local: <Store />,
  Terreno: <Fence />,
  "Casa independiente": <NightShelter />,
  Penthouse: <CorporateFare />,
  Townhouse: <Apartment />,
  "Apartamento loft": <MapsHomeWork />,
  "Apartamento estudio": <EmojiTransportation />,
  "Casa de lujo": <House />,
  Moderna: <AccountBalance />,
  Rústica: <Bungalow />,
  "Propiedad Comercial": <Storefront />,
  Oficentro: <LocalConvenienceStoreIcon />,
  Mall: <StoreMallDirectoryIcon />,
  Mansión: <Villa />,
  "No disponible": <Lock />,
};

const SearchContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1),
  height: "35px",
  border: "1px solid lightgray",
  borderRadius: "999px",
  width: "100%",
  maxWidth: "400px",
  position: "relative",
  marginBottom: 2,
  backgroundColor: alpha(theme.palette.common.black, 0.05),
  boxShadow: theme.shadows[1],
  "&:hover": {
    boxShadow: theme.shadows[4],
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  flexGrow: 1,
  marginLeft: theme.spacing(1),
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    transition: theme.transitions.create("width"),
    width: "100%",
  },
}));

const IconGroupContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 10px",
  borderRadius: "20px",
  backgroundColor: alpha(theme.palette.common.black, 0.05),
  boxShadow: theme.shadows[1],
  [theme.breakpoints.down("sm")]: {
    padding: "2px 4px",
    gap: "2px",
  },
  [theme.breakpoints.up("sm")]: {
    padding: "6px 10px",
    gap: "6px",
  },
  [theme.breakpoints.up("md")]: {
    padding: "8px 12px",
    gap: "8px",
  },
  "&:hover": {
    boxShadow: theme.shadows[4],
  },
}));

const ResponsiveImage = styled("img")(({ theme }) => ({
  borderRadius: "50%",
  width: "35px",
  height: "35px",
  [theme.breakpoints.down("md")]: {
    width: "30px",
    height: "30px",
  },
  [theme.breakpoints.down("sm")]: {
    width: "25px",
    height: "25px",
  },
}));

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  width: "35px",
  height: "35px",
  padding: 0,
  borderRadius: "50%",
}));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  display: "flex",
  justifyContent: "center",
  margin: "10px 0",
  height: "40px",
});

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  "&.Mui-selected": {
    backgroundColor: theme.palette.secondary.main,
    color: "white",
  },
  "&:not(.Mui-selected)": {
    backgroundColor: "#f0f0f0",
    color: "#000",
  },
  "&:hover": {
    backgroundColor: "#e0e0e0",
  },
  borderRadius: "8px",
  margin: "0 5px",
  fontWeight: "bold",
}));

interface HeaderProps {
  showFilterOptions?: boolean;
}

const Header: React.FC<HeaderProps> = ({ showFilterOptions = true }) => {
  const theme = useTheme();
  const {
    tokenKey,
    photoUrl,
    logout,
    wasLoggedIn,
    name,
    decodeIdToken,
    setWasLoggedIn,
    isBroker,
    isAdmin,
    userToken,
  } = useAuth();
  const {
    filterPropertiesByCategory,
    filterPropertiesByMode,
    searchProperties,
    filteredProperties,
    propertyCountByCategory,
    setIsOpenChatBubble,
    setSearchTermForAri,
    setIsTextFromSearch,
  } = useProperty();
  const { searchPosts } = usePost();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { sellRate, buyRate } = useCurrency();

  const [selectedButton, setSelectedButton] = useState<string | null>(
    Object.keys(iconMapping)[0]
  );
  const [showDivider, setShowDivider] = useState(true);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isFirstImage, setIsFirstImage] = useState(true);

  const [openAuthModal, setOpenAuthModal] = useState(false);
  const [openWelcomeBackModal, setOpenWelcomeBackModal] = useState(false);
  const [openConvertModal, setOpenConvertModal] = useState(false);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [openRealEstateModal, setOpenRealEstateModal] = useState(false);
  const [openBrokerProfileRequiredModal, setOpenBrokerProfileRequiredModal] =
    useState(false);
  const [transactionType, setTransactionType] = useState<string>("Todos");

  const [greeting, setGreeting] = useState("");
  const [showContent, setShowContent] = useState(true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [searchTerm, setSearchTerm] = useState("");
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const location = useLocation();
  const params = useParams();
  const [messageCount, setMessageCount] = useState<number>(0);

  const [showPropertyCounter, setShowPropertyCounter] = useState(false);
  const [propertyCount, setPropertyCount] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null) 
  // const getUserProfileId = () => {

  //   if (!userToken?.user?.profiles || userToken.user.profiles.length === 0) {
  //     return undefined
  //   }

  //   const brokerProfile = userToken.user.profiles.find((profile) => profile.roleName === "Broker")
  //   if (brokerProfile) {
  //     return brokerProfile.id
  //   }

  //   const clientProfile = userToken.user.profiles.find((profile) => profile.roleName === "Cliente")
  //   if (clientProfile) {
  //     return clientProfile.id
  //   }
  //   return userToken.user.profiles[0].id
  // }

  const isCompanyPath = location.pathname.startsWith("/company/");
  const companyUrl = isCompanyPath ? params.pageUrl : null;

  const getTabIndex = (path: string) => {
    if (path.includes("/properties")) return 0;
    if (path.includes("/channels")) return 1;
    if (path.includes("/posts")) return 2;
    return 0;
  };


  const [selectedTab, setSelectedTab] = useState(
    getTabIndex(location.pathname)
  );

  useEffect(() => {
    setSelectedTab(getTabIndex(location.pathname));
  }, [location.pathname]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);

    const basePath = isCompanyPath ? `/company/${companyUrl}` : "";

    switch (newValue) {
      case 0:
        navigate(`${basePath}/properties/home`);
        break;
      case 1:
        navigate(`${basePath}/channels/home`);
        break;
      case 2:
        navigate(`${basePath}/posts/home`);
        break;
      default:
        navigate(`${basePath}/properties/home`);
    }
  };

  const openAdminPanel = () => {
    let base = "https://alienrealtyweb-admin-cbhmaugqcdbkcnf3.centralus-01.azurewebsites.net";

    let url = base + "/admin-panel/home";

    if (isCompanyPath && companyUrl) {
      url = `${base}/company/${companyUrl}/admin-panel/home`;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  };


  const isMobile = useMediaQuery("(max-width:1024px)");
  const isSmallMobile = useMediaQuery("(max-width:480px)");

  const handleBrokerProfileRequiredModalOpen = () => {
    setOpenBrokerProfileRequiredModal(true);
  };

  const handleBrokerProfileRequiredModalClose = () => {
    setOpenBrokerProfileRequiredModal(false);
  };

  const handleOpenRealEstateModal = () => setOpenRealEstateModal(true);
  const handleCloseRealEstateModal = () => setOpenRealEstateModal(false);

  const handleOpenSettingsModal = () => setOpenSettingsModal(true);
  const handleCloseSettingsModal = () => setOpenSettingsModal(false);

  const handleLogout = async () => {
    localStorage.removeItem("googleIdToken");
    setWasLoggedIn(false);
    logout();
  };

  const handleButtonClick = (category: string) => {
    if (selectedButton === category) {
      return;
    } else {
      if (category === "Torre") {
        handleOpenRealEstateModal();
      }
      setSelectedButton(category);
      filterPropertiesByCategory(category);
      setSelectedButton(category);
    }
  };


  const handleDynamicButtonClick = () => {
    if (tokenKey) {
      if ((isBroker || isAdmin) && selectedTab === 0) {
        handleNavigate("publish-property");
      } else if (selectedTab === 2) {
        handleNavigate("create-post");
      } else if (selectedTab === 1) {
        handleNavigate("create-channel");
      } else {
        handleBrokerProfileRequiredModalOpen();
      }
    } else {
      if (wasLoggedIn) {
        handleWelcomeBackModalOpen();
      } else {
        handleAuthModalOpen();
      }
    }
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAuthModalOpen = () => {
    setOpenWelcomeBackModal(false);
    setOpenAuthModal(true);
  };

  const handleAuthModalClose = () => {
    setOpenAuthModal(false);
  };

  const handleWelcomeBackModalOpen = () => {
    const googleToken = localStorage.getItem("googleIdToken");
    decodeIdToken(googleToken!);
    setOpenWelcomeBackModal(true);
  };

  const handleWelcomeBackModalClose = () => {
    setOpenWelcomeBackModal(false);
  };

  const handleConvertModalOpen = () => {
    setOpenConvertModal(true);
  };

  const handleConvertModalClose = () => {
    setOpenConvertModal(false);
  };

  const handleFilterModalOpen = () => {
    setOpenFilterModal(false);
    setOpenFilterModal(true);
  };

  const handleFilterModalClose = () => {
    setOpenFilterModal(false);
  };

  const handleNavigate = (path: string) => {
    const basePath = isCompanyPath && companyUrl ? `/company/${companyUrl}` : "";
    navigate(`${basePath}/properties/${path}`);
    handleMenuClose();
  };


  const handleLogoClick = () => {
    navigate("/");
    window.location.reload();
  };

  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const scroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount = 400;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const updateArrowVisibility = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;

      setShowLeftArrow(container.scrollLeft > 0);

      setShowRightArrow(container.scrollLeft < maxScrollLeft);
    }
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (setSearchTermForAri) {
      setSearchTermForAri(term);
    }
    if (selectedTab === 0) {
      searchProperties(term);
    } else {
      searchPosts(term);
    }
  };

  const handleTransactionTypeChange = (
    event: React.MouseEvent<HTMLElement>,
    newTransactionType: string | null
  ) => {
    if (newTransactionType !== null && newTransactionType !== transactionType) {
      setTransactionType(newTransactionType);
      filterPropertiesByMode(newTransactionType);
    } else if (newTransactionType === null) {
      setTransactionType("Todos");
      filterPropertiesByMode("Todos");
    }
  };

  useEffect(() => {
    updateArrowVisibility();

    if (scrollContainerRef.current) {
      scrollContainerRef.current.addEventListener(
        "scroll",
        updateArrowVisibility
      );
    }
    window.addEventListener("resize", updateArrowVisibility);

    return () => {
      if (scrollContainerRef.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        scrollContainerRef.current.removeEventListener(
          "scroll",
          updateArrowVisibility
        );
      }
      window.removeEventListener("resize", updateArrowVisibility);
    };
  }, []);

  useEffect(() => {
    const currentHour = new Date().getHours();
    const greet =
      currentHour < 12
        ? "Buenos días"
        : currentHour < 18
        ? "Buenas tardes"
        : "Buenas noches";
    setGreeting(greet);
  }, [tokenKey]);

  useEffect(() => {
    const fetchMessageCount = async () => {
      if (!tokenKey || !userToken) return;

      const getUserProfileId = () => {
        if (
          !userToken?.user?.profiles ||
          userToken.user.profiles.length === 0
        ) {
          return undefined;
        }

        const brokerProfile = userToken.user.profiles.find(
          (profile) => profile.roleName === "Broker"
        );
        if (brokerProfile) return brokerProfile.id;

        const clientProfile = userToken.user.profiles.find(
          (profile) => profile.roleName === "Cliente"
        );
        if (clientProfile) return clientProfile.id;

        return userToken.user.profiles[0].id;
      };

      try {
        const userProfileId = getUserProfileId();
        if (!userProfileId) return;

        let conversations: any[] = [];

        try {
          const signalRConversations = await getConversationsViaHub(
            userProfileId
          );
          if (Array.isArray(signalRConversations)) {
            conversations = signalRConversations;
          }
        } catch {
          const restConversations = await getConversationsREST(userProfileId);
          if (Array.isArray(restConversations)) {
            conversations = restConversations;
          }
        }

        const totalUnread = conversations.reduce(
          (acc, conv) => acc + (conv.unreadCount || 0),
          0
        );
        setMessageCount(totalUnread);
      } catch (error) {
        console.error("❌ Error al obtener el recuento de mensajes:", error);
      }
    };

    fetchMessageCount();
    const intervalId = setInterval(fetchMessageCount, 30000);
    return () => clearInterval(intervalId);
  }, [tokenKey, userToken]);

   useEffect(() => {
    const count = filteredProperties.length;

    setPropertyCount(count);

    setShowPropertyCounter(true);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    if (count > 0) {
      timerRef.current = setTimeout(() => {
        setShowPropertyCounter(false);
      }, 5000);
    } else {
      setShowPropertyCounter(false);
    }

    // Cleanup
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [filteredProperties.length]);

  const realtorId = userToken?.user.profiles.find(p => p.roleName === "Broker")?.realtor?.id;

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFirstImage((prev) => !prev);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <AppBar
      position="sticky"
      color="inherit"
      elevation={2}
      sx={{
        width: "100%",
        margin: 0,
        padding: 0,
        left: 0,
        right: 0,
        background: `linear-gradient(180deg, ${theme.palette.background.default} 0%, rgba(248, 249, 250, 0.95) 100%)`,
      }}
    >
      <Box sx={{ width: "100%", alignItems: "center", justifyContent: "space-between", px: { xs: 2, md:4 }, boxSizing: "border-box", }}>
        {/* Barra de herramientas con logo, búsqueda e iconos */}
        <Toolbar 
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            px: { xs: isSmallMobile ? 0 : 0, sm: 0 },
            minHeight: { xs: isSmallMobile ? "48px" : "56px", sm: "64px" },
          }}
        >
          {/* Logo a la izquierda */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
               flexShrink: 0,
              cursor: "pointer",
            }}
          >
            <LogoAnimated isFirstImage={isFirstImage} handleLogoClick={handleLogoClick} />

            {/* Nave animada */}
            <Box
              sx={{
                position: "relative",
                marginLeft: { xs: isSmallMobile ? 15 : 18, md: 30 },
                cursor: "pointer",
                animation: `${floatAnimation} 2s infinite ease-in-out`,
                "&:hover .messageBox": { opacity: 1, transform: "scale(1)" },
              }}
              onClick={() => {
                if (isCompanyPath) {
                  window.location.href = "https://www.camara.cr/";
                } else {
                  window.location.href = "https://alienrealty.orbitascr.com/";
                }
              }}
            >
              <Box
                component="img"
                src={isCompanyPath ? "/assets/images/house1.png" : "/assets/images/nave2.png"}
                alt="Nave Espacial"
                sx={{
                  width: { xs: 30, sm: 40, md: 50 },
                  height: "auto",
                }}
              />

              {/* Mensaje emergente */}
              <Box
                className="messageBox"
                sx={{
                  position: "absolute",
                  bottom: "20%",
                  left: "100%",
                  transform: "translateX(-50%) scale(0.8)",
                  backgroundColor: theme.palette.secondary.main,
                  color: "white",
                  padding: "6px 12px",
                  borderRadius: "8px",
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  opacity: 0,
                  transition:
                    "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
                  boxShadow: "0px 0px 5px cyan",
                }}
              >
                🚀 Visita nuestra página informativa
              </Box>
            </Box>

            {/* Componente adicional */}
            <ActiveUsers />
          </Box>

          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              flexDirection: "column",
              flex: 2,
              alignItems: "center",
              maxWidth: { xs: "100%", sm: "60%", md: "50%" },
            }}
          >
            {/* Tabs solo en pantallas medianas y grandes */}
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              aria-label="search tabs"
              variant="fullWidth"
              TabIndicatorProps={{
                sx: {
                  height: "4px",
                  borderRadius: "2px",
                  bgcolor: "secondary.main",
                  transition: "all 0.3s ease",
                },
              }}
              sx={{
                display: { xs: "none", sm: "inline-flex" },
                bgcolor: 'transparent',
                borderRadius: "10px",
                minHeight: "30px",
                padding: "3px",
                mb: 1,
              }}
            >
              <Tab
                label="Propiedades"
                icon={<FontAwesomeIcon icon={faHouseUser} />}
                iconPosition="start"
                sx={{
                  color: selectedTab === 0 ? "secondary.main" : "black",
                   "&.Mui-selected": {
                    color: theme.palette.secondary.main,
                    "& .MuiTab-iconWrapper": { color: theme.palette.secondary.main },
                  },
                  fontWeight: 500,
                  textTransform: "none",
                  opacity: selectedTab === 0 ? 1 : 0.7,
                  transition: "all 0.3s ease",
                  "&:hover": { opacity: 1 },
                  minHeight: "30px",
                  padding: "5px 12px",
                }}
              />
              {tokenKey && (
                <Tab
                  label={"Canales"}
                  icon={<FontAwesomeIcon icon={faComments} />}
                  iconPosition="start"
                  sx={{
                    color: selectedTab === 1 ? "secondary.main" : "black",
                    "&.Mui-selected": {
                      color: theme.palette.secondary.main,
                    "& .MuiTab-iconWrapper": { color: theme.palette.secondary.main },
                    },
                    fontSize: "13px",
                    fontWeight: 500,
                    textTransform: "none",
                    opacity: selectedTab === 1 ? 1 : 0.7,
                    transition: "all 0.3s ease",
                    "&:hover": { opacity: 1 },
                    minHeight: "30px",
                    padding: "5px 12px",
                  }}
                />
              )}
              <Tab
                label={!tokenKey || !isBroker ? "Busco" : "Oportunidades"}
                icon={<FontAwesomeIcon icon={faBriefcase} />}
                iconPosition="start"
                sx={{
                  color: selectedTab === 2 ? "secondary.main" : "black",
                  "&.Mui-selected": {
                    color: theme.palette.secondary.main,
                    "& .MuiTab-iconWrapper": { color: theme.palette.secondary.main },
                  },
                  fontSize: "13px",
                  fontWeight: 500,
                  textTransform: "none",
                  opacity: selectedTab === 2 ? 1 : 0.7,
                  transition: "all 0.3s ease",
                  "&:hover": { opacity: 1 },
                  minHeight: "30px",
                  padding: "5px 12px",
                }}
              />
            </Tabs>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                gap: 2,
                justifyContent: "center",
                mt: { xs: 8, sm: 0 },
              }}
            >
              {/* Search - siempre visible */}
              <SearchContainer sx={{ maxWidth: "400px", bgcolor: "white" }}>
                <StyledInputBase
                  placeholder={t("searchPlaceholder")}
                  inputProps={{ "aria-label": "search" }}
                  onChange={handleSearch}
                />
                <>
                  <IconButton
                    color="inherit"
                    sx={{
                      padding: 1,
                      backgroundColor: "secondary.main",
                      color: "white",
                      borderRadius: "50%",
                      "&:hover": {
                        backgroundColor: "secondary.main",
                        boxShadow: 3,
                      },
                    }}
                  >
                    <Search />
                  </IconButton>

                  {/* Botón para abrir filtros */}
                  {selectedTab === 0 && (
                    <>
                      <Tooltip title={"Búsqueda avanzada"} placement={"bottom"}>
                        <IconButton
                          onClick={handleFilterModalOpen}
                          sx={{
                            padding: 1,
                            marginLeft: 1,
                            backgroundColor: "#f0f0f0",
                            color: "secondary.main",
                            borderRadius: "50%",
                            "&:hover": {
                              backgroundColor: "#e0e0e0",
                              boxShadow: 2,
                            },
                          }}
                        >
                          <Tune />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={"Busca con Ari"} placement={"bottom"}>
                        <IconButton
                          onClick={() => {
                            setIsTextFromSearch && setIsTextFromSearch(true);
                            setIsOpenChatBubble && setIsOpenChatBubble(true);
                          }}
                          sx={{
                            padding: 1,
                            marginLeft: 1,
                            backgroundColor: "#f0f0f0",
                            color: "#6a1b9a",
                            borderRadius: "50%",
                            "&:hover": {
                              backgroundColor: "#e0e0e0",
                              boxShadow: 2,
                            },
                          }}
                          disabled={searchTerm.length === 0}
                        >
                          <AutoAwesome />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </>
              </SearchContainer>

              {/* Contador de propiedades - siempre visible */}
              {showPropertyCounter && (
                <Box
                  sx={{
                    backgroundColor: "rgba(76, 175, 80, 0.9)",
                    color: "white",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    textAlign: "center",
                    animation: "fadeInOut 5s forwards",
                    "@keyframes fadeInOut": {
                      "0%": { opacity: 0, transform: "translateX(10px)" },
                      "10%": { opacity: 1, transform: "translateX(0)" },
                      "80%": { opacity: 1, transform: "translateX(0)" },
                      "100%": { opacity: 0, transform: "translateX(10px)" },
                    },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    whiteSpace: "nowrap",
                    minWidth: "fit-content",
                  }}
                >
                  <FilterList sx={{ mr: 1, fontSize: "16px" }} />
                  <Typography variant="body2" fontWeight="bold">
                    ¡{propertyCount}!
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          {/* Botones e Iconos a la derecha */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flex: { xs: 1, md: 1 },
              paddingRight: 2,
            }}
          >
            {!isMobile && (
              <>
                <Button
                  color="inherit"
                  sx={{ mr: 2 }}
                  onClick={handleDynamicButtonClick}
                >
                  {selectedTab === 2
                    ? "Crea una publicación"
                    : tokenKey && (isBroker || isAdmin)
                    ? "Modo Broker"
                    : "Publica una propiedad"}
                </Button>
              </>
            )}

            <IconButton
              color="inherit"
              sx={{ mr: { xs: 0, sm: 2 } }}
              onClick={handleOpenSettingsModal}
            >
              <Settings />
            </IconButton>

            <SettingsModal
              open={openSettingsModal}
              onClose={handleCloseSettingsModal}
            />

            {/* Icono de Menú y Perfil de Usuario */}
            <IconGroupContainer
              onClick={handleMenuClick}
              sx={{
                display: { xs: "none", sm: "flex" },
                bgcolor: "white",
              }}
            >
              <MenuIcon />
              {photoUrl ? (
                <IconButtonStyled disableTouchRipple disableFocusRipple>
                  <Badge
                    badgeContent={messageCount}
                    color="success"
                    invisible={messageCount === 0}
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#4caf50",
                        color: "white",
                        fontSize: "0.7rem",
                        height: "18px",
                        minWidth: "18px",
                        padding: "0 4px",
                        boxShadow: "0px 0px 3px rgba(0,0,0,0.3)",
                      },
                    }}
                  >
                    <ResponsiveImage src={photoUrl} alt="User" />
                  </Badge>
                </IconButtonStyled>
              ) : (
                <IconButtonStyled>
                  <Badge
                    badgeContent={messageCount}
                    color="success"
                    invisible={messageCount === 0}
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: "#4caf50",
                        color: "white",
                        fontSize: "0.7rem",
                        height: "18px",
                        minWidth: "18px",
                        padding: "0 4px",
                        boxShadow: "0px 0px 3px rgba(0,0,0,0.3)",
                      },
                    }}
                  >
                    <AccountCircle
                      sx={{
                        width: { xs: "25px", md: "35px" },
                        height: { xs: "25px", md: "35px" },
                      }}
                    />
                  </Badge>
                </IconButtonStyled>
              )}
            </IconGroupContainer>
          </Box>
        </Toolbar>

        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px:2,
            boxSizing: "border-box",
            flexWrap: "wrap",
          }}
        >
          {/* Saludo (35%) */}
          <Box
            sx={{
              width: { xs: "100%", sm: "35%" },
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "space-between", sm: "flex-start" },
              gap: { xs: 1, sm: 0 },
            }}
          >
            {new Date().getHours() < 12 ? (
              <WbSunny
                sx={{
                  fontSize: { xs: isSmallMobile ? "16px" : "20px", md: "25px" },
                  color: "gold",
                  mx: 1,
                  display: { xs: "none", sm: "flex" },
                }}
              />
            ) : new Date().getHours() < 18 ? (
              <Brightness4
                sx={{
                  fontSize: { xs: isSmallMobile ? "16px" : "20px", md: "25px" },
                  color: "orange",
                  mx: 1,
                  display: { xs: "none", sm: "flex" },
                }}
              />
            ) : (
              <NightsStay
                sx={{
                  fontSize: { xs: isSmallMobile ? "16px" : "20px", md: "25px" },
                  color: "darkblue",
                  mx: 1,
                  display: { xs: "none", sm: "flex" },
                }}
              />
            )}
            <Typography
              variant="h6"
              sx={{
                fontFamily: "'Roboto Slab', serif",
                color: "#4B4B4B",
                fontWeight: "bold",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: {
                  xs: isSmallMobile ? "12px" : "14px",
                  sm: 14,
                  md: "16px",
                  xl: 18,
                },
                display: { xs: "none", sm: "flex" },
                alignItems: "center",
                gap: 1,
              }}
            >
              {greeting} {tokenKey && name}
            </Typography>
            <Box
              sx={{
                display: { xs: "flex", sm: "none" },
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                gap: 1,
              }}
            >
              {/* Barra de búsqueda */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 0.5,
                  width: "100%",
                }}
              >
                <SearchContainer
                  sx={{
                    width: "100%",
                    height: "30px",
                    backgroundColor: "#FFFFFF",
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <StyledInputBase
                    placeholder={t("searchPlaceholder")}
                    inputProps={{ "aria-label": "search" }}
                    onChange={handleSearch}
                    sx={{ fontSize: "12px" }}
                  />
                  <IconButton
                    color="inherit"
                    sx={{
                      padding: 0.5,
                      color: "black",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      "&:hover": {
                        backgroundColor: "darkgreen",
                        boxShadow: 3,
                      },
                    }}
                  >
                    <Search sx={{ fontSize: "14px" }} />
                  </IconButton>
                  {selectedTab === 0 && (
                    <>
                      <Tooltip title={"Búsqueda avanzada"} placement={"bottom"}>
                        <IconButton
                          onClick={handleFilterModalOpen}
                          sx={{
                            padding: 1,
                            marginLeft: 1,
                            backgroundColor: "#f0f0f0",
                            color: "green",
                            borderRadius: "50%",
                            "&:hover": {
                              backgroundColor: "#e0e0e0",
                              boxShadow: 2,
                            },
                          }}
                        >
                          <Tune sx={{ fontSize: "14px" }} />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title={"Busca con Ari"} placement={"bottom"}>
                        <IconButton
                          onClick={() => {
                            setIsTextFromSearch && setIsTextFromSearch(true);
                            setIsOpenChatBubble && setIsOpenChatBubble(true);
                          }}
                          sx={{
                            padding: 1,
                            marginLeft: 1,
                            backgroundColor: "#f0f0f0",
                            color: "#749a1bff",
                            borderRadius: "50%",
                            "&:hover": {
                              backgroundColor: "#e0e0e0",
                              boxShadow: 2,
                            },
                          }}
                          disabled={searchTerm.length === 0}
                        >
                          <AutoAwesome sx={{ fontSize: "14px" }} />
                        </IconButton>
                      </Tooltip>
                    </>
                  )}
                </SearchContainer>

                {/* Contador sigue al lado */}
                  <Box
                    sx={{
                      opacity: showPropertyCounter ? 1 : 0,
                      visibility: showPropertyCounter ? 'visible' : 'hidden', 
                      transform: showPropertyCounter ? "translateX(0)" : "translateX(10px)",
                      transition: "opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease",
                      backgroundColor: "rgba(76, 175, 80, 0.9)",
                      color: "white",
                      padding: "2px 8px",
                      borderRadius: "12px",
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                      whiteSpace: "nowrap",
                      minWidth: "fit-content",
                      position: "absolute",
                      top: 8,
                      right: 8,
                      zIndex: 1000,
                      pointerEvents: "none",
                      fontSize: "12px",
                      lineHeight: 1,
                    }}
                  >
                    <FilterList sx={{ mr: 0.5, fontSize: "12px" }} />
                    <Typography
                      variant="caption"
                      fontWeight="bold"
                      sx={{ fontSize: "10px" }}
                    >
                      ¡{propertyCount}!
                    </Typography>
                  </Box>
              </Box>

              {/* Tabs debajo */}
              <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="mobile search tabs"
                variant="fullWidth"
                TabIndicatorProps={{
                  sx: {
                    height: "3px",
                    borderRadius: "2px",
                    bgcolor: "secondary.main",
                    transition: "all 0.3s ease",
                  },
                }}
                sx={{
                  bgcolor: "white",
                  borderRadius: "8px",
                  minHeight: "30px",
                  padding: "2px",
                  width: "100%",
                }}
              >
                <Tab
                  label="Propiedades"
                  icon={<FontAwesomeIcon icon={faHouseUser} />}
                  iconPosition="start"
                  sx={{
                    color: selectedTab === 0 ? "secondary.main" : "black",
                    "&.Mui-selected": {
                      color: theme.palette.secondary.main,
                      "& .MuiTab-iconWrapper": { color: theme.palette.secondary.main },
                    },
                    fontSize: "12px",
                    fontWeight: 500,
                    textTransform: "none",
                    opacity: selectedTab === 0 ? 1 : 0.7,
                    transition: "all 0.3s ease",
                    "&:hover": { opacity: 1 },
                    minHeight: "28px",
                    padding: "4px 8px",
                  }}
                />
                {tokenKey && (
                  <Tab
                    label="Canales"
                    icon={<FontAwesomeIcon icon={faComments} />}
                    iconPosition="start"
                    sx={{
                      color: selectedTab === 1 ? "secondary.main" : "black",
                     "&.Mui-selected": {
                        color: theme.palette.primary.main,
                        "& .MuiTab-iconWrapper": { color: theme.palette.secondary.main },
                      },
                      fontSize: "12px",
                      fontWeight: 500,
                      textTransform: "none",
                      opacity: selectedTab === 1 ? 1 : 0.7,
                      transition: "all 0.3s ease",
                      "&:hover": { opacity: 1 },
                      minHeight: "28px",
                      padding: "4px 8px",
                    }}
                  />
                )}
                <Tab
                  label={!tokenKey || !isBroker ? "Busco" : "Oportunidades"}
                  icon={<FontAwesomeIcon icon={faBriefcase} />}
                  iconPosition="start"
                  sx={{
                    color: selectedTab === 2 ? "secondary.main" : "black",
                    "&.Mui-selected": {
                      color: theme.palette.secondary.main,
                      "& .MuiTab-iconWrapper": { color: theme.palette.secondary.main },
                    },
                    fontSize: "12px",
                    fontWeight: 500,
                    textTransform: "none",
                    opacity: selectedTab === 2 ? 1 : 0.7,
                    transition: "all 0.3s ease",
                    "&:hover": { opacity: 1 },
                    minHeight: "28px",
                    padding: "4px 8px",
                  }}
                />
              </Tabs>
            </Box>
          </Box>

          {/* Filtro (30%) */}
          {selectedTab !== 1 && (
            <Box
              sx={{
                width: { xs: "100%", sm: "30%" },
                display: { xs: "none", md: "flex" },
                justifyContent: "start",
                alignItems: "center",
                mt: { xs: 1, sm: 0 },
              }}
            >
              {/* Aquí puedes poner el filtro de alquilar/comprar/todos */}
              <StyledToggleButtonGroup
                value={transactionType}
                exclusive
                onChange={handleTransactionTypeChange}
              >
                <StyledToggleButton value="Todos">Todas</StyledToggleButton>
                <StyledToggleButton value="Alquiler">
                  Alquilar
                </StyledToggleButton>
                <StyledToggleButton value="Venta">Comprar</StyledToggleButton>
              </StyledToggleButtonGroup>
            </Box>
          )}

          {/* Tipo de Cambio (35%) */}
          <Box
            sx={{
              display: { xs: "none", sm: "flex" },
              justifyContent: "space-between",
              gap: 2,
              alignItems: "center",
              mt: { xs: 1, sm: 0 },
            }}
          >
            {/* Título a la izquierda */}
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#4B4B4B",
                fontFamily: "'Roboto Slab', serif",
                fontSize: {
                  xs: isSmallMobile ? "12px" : "14px",
                  sm: 14,
                  md: "16px",
                  xl: 18,
                },
              }}
            >
              Tipo de cambio (BCCR):
            </Typography>

            {/* Valores a la derecha */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              {/* Compra */}
              <Box sx={{ textAlign: "right" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    color: "green",
                    fontSize: {
                      xs: isSmallMobile ? "10px" : "12px",
                      sm: 12,
                      md: "14px",
                      xl: 16,
                    },
                    fontFamily: "'Roboto Slab', serif",
                  }}
                >
                  Compra
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <AttachMoney
                    sx={{
                      fontSize: {
                        xs: isSmallMobile ? "10px" : "12px",
                        sm: 12,
                        md: "14px",
                        xl: 16,
                      },
                      color: "green",
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      color: "green",
                      fontSize: {
                        xs: isSmallMobile ? "10px" : "12px",
                        sm: 12,
                        md: "14px",
                        xl: 16,
                      },
                      fontFamily: "'Roboto Slab', serif",
                    }}
                  >
                    {buyRate ? buyRate : "N/A"}
                  </Typography>
                </Box>
              </Box>

              {/* Venta */}
              <Box sx={{ textAlign: "right" }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    color: "red",
                    fontSize: {
                      xs: isSmallMobile ? "10px" : "12px",
                      sm: 12,
                      md: "14px",
                      xl: 16,
                    },
                    fontFamily: "'Roboto Slab', serif",
                  }}
                >
                  Venta
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <MoneyOff
                    sx={{
                      fontSize: {
                        xs: isSmallMobile ? "10px" : "12px",
                        sm: 12,
                        md: "14px",
                        xl: 16,
                      },
                      color: "red",
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{
                      color: "red",
                      fontSize: {
                        xs: isSmallMobile ? "10px" : "12px",
                        sm: 12,
                        md: "14px",
                        xl: 16,
                      },
                      fontFamily: "'Roboto Slab', serif",
                    }}
                  >
                    {sellRate ? sellRate : "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Menu Desplegable */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            width: "200px",
          },
        }}
      >
        {!tokenKey ? (
          <>
            <MenuItem
              key="login"
              onClick={() => {
                wasLoggedIn
                  ? handleWelcomeBackModalOpen()
                  : handleAuthModalOpen();
                handleMenuClose();
              }}
            >
              Iniciar Sesión
            </MenuItem>
            <MenuItem
              key="register"
              onClick={() => {
                wasLoggedIn
                  ? handleWelcomeBackModalOpen()
                  : handleAuthModalOpen();
                handleMenuClose();
              }}
            >
              Registrarse
            </MenuItem>
            <Divider key="divider2" />
            <MenuItem key="convert" onClick={handleConvertModalOpen}>
              Convertir Precio
            </MenuItem>
            <Divider key="divider3" />
            <MenuItem
              key="download-android-guest"
              onClick={() => {
                window.location.href =
                  "https://play.google.com/store/apps/details?id=com.orbitas.alien_realty_app";
                handleMenuClose();
              }}
            >
              Descarga para Android
            </MenuItem>
            <MenuItem
              key="download-android-guest"
              onClick={() => {
                window.location.href =
                  "https://apps.apple.com/cr/app/alien-realty-app/id6738670454";
                handleMenuClose();
              }}
            >
              Descarga para iOS
            </MenuItem>
          </>
        ) : (
          <>
            <MenuItem key="logout" onClick={() => handleLogout()}>
              Cerrar sesión
            </MenuItem>
            <Divider key="divider2" />
            {isBroker && (
                        <MenuItem
                          key="profile"
                          onClick={() => handleNavigate(`realtor/${realtorId}`)}
                        >
                          Ver perfil
                        </MenuItem>
                      )}
            <MenuItem key="messages" onClick={() => handleNavigate("messages")}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <span>Ver mensajes</span>
                {messageCount > 0 && (
                  <Badge
                    badgeContent={messageCount}
                    invisible={messageCount === 0}
                    color="success"
                    sx={{
                      "& .MuiBadge-badge": {
                        fontSize: "0.75rem",
                        height: "20px",
                        minWidth: "20px",
                        backgroundColor: "#4caf50",
                        color: "white",
                      },
                    }}
                  />
                )}
              </Box>
            </MenuItem>
            {selectedTab === 0 && (
              <MenuItem
                key="favorites"
                onClick={() => handleNavigate("favorites")}
              >
                Lista de favoritos
              </MenuItem>
            )}
            {tokenKey && (isBroker || isAdmin) ? (
              <MenuItem
                key="publish"
                onClick={() =>
                  handleNavigate(
                    selectedTab === 0 ? "publish-property" : "create-post"
                  )
                }
              >
                {selectedTab === 0
                  ? "Publica una propiedad"
                  : "Publica una oportunidad"}
              </MenuItem>
            ) : null}
            <MenuItem key="convert" onClick={handleConvertModalOpen}>
              Convertir precio
            </MenuItem>
            <MenuItem
              key="admin-account"
              onClick={(e) => {
                e.preventDefault();
                openAdminPanel();
              }}
            >
              Gestión Inmobiliaria
            </MenuItem>

            <MenuItem
              key="modules"
              onClick={() => {
                handleNavigate("modules-page");
                handleMenuClose();
              }}
            >
              Módulos
            </MenuItem>
            <Divider key="divider3" />
            <MenuItem
              key="download-android"
              onClick={() => {
                window.location.href =
                  "https://play.google.com/store/apps/details?id=com.orbitas.alien_realty_app";
                handleMenuClose();
              }}
            >
              Descarga para Android
            </MenuItem>
            <MenuItem
              key="download-android-guest"
              onClick={() => {
                window.location.href =
                  "https://apps.apple.com/cr/app/alien-realty-app/id6738670454";
                handleMenuClose();
              }}
            >
              Descarga para iOS
            </MenuItem>
          </>
        )}
      </Menu>

      {showDivider && selectedTab !== 1 && (
        <Box sx={{ width: "100%" }}>
          <Divider
            sx={{
              width: "100%",
              my: showFilterOptions ? 1 : 0,
              borderColor: "lightgray",
            }}
          />
        </Box>
      )}

      {/* Botón para abrir/cerrar */}
      {selectedTab !== 1 && showFilterOptions && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            right: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            backgroundColor: "transparent",
            borderRadius: "50%",
            padding: "8px",
            "&:hover": {
              backgroundColor: "transparent",
            },
          }}
          onClick={() => {
            setShowContent(!showContent);
            setShowDivider(!showDivider);
          }}
        >
          {/* Flecha pequeña a la izquierda (si se muestra contenido) */}
          {showContent ? (
            <FontAwesomeIcon icon={faChevronUp} size="sm" />
          ) : (
            <FontAwesomeIcon icon={faChevronDown} size="sm" />
          )}
        </Box>
      )}

      {showFilterOptions && selectedTab !== 1 && (
        <Box
          sx={{
            alignItems: "center",
            margin: { xs: "0px 10px", md: "0px 30px" },
            display: showContent ? "flex" : "none",
            opacity: showContent ? 1 : 0,
            transition: "opacity 0.5s ease, max-height 0.5s ease",
          }}
        >
          {showLeftArrow && (
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <FontAwesomeIcon
                size="xl"
                onClick={() => scroll("left")}
                icon={faCircleArrowLeft}
                className="arrow"
              />
            </Box>
          )}
          <Box
            ref={scrollContainerRef}
            sx={{
              display: "flex",
              flexDirection: "row",
              overflowX: { xs: "auto", md: "hidden" },
              whiteSpace: "nowrap",
              gap: 2,
              py: 1,
              px: { xs: 1, sm: 2 },
            }}
          >
            {Object.keys(iconMapping).map((option) => (
              <IconButton
                key={option}
                sx={{
                  flexDirection: "column",
                  mx: 1,
                  color:
                    selectedButton === option
                      ? theme.palette.success.main
                      : "rgba(0, 0, 0, 0.6)",
                  borderRadius: 0,
                  border: "none",
                  "&:hover": {
                    backgroundColor: "white",
                    color: "black",
                    boxShadow: "0px 2px 0px rgba(0, 0, 0, 0.3)",
                  },
                  boxShadow:
                    selectedButton === option
                      ? "0px 2px 0px rgba(0, 0, 0, 0.8)"
                      : "none",
                  transition: "box-shadow 0.3s ease",
                }}
                onClick={() => handleButtonClick(option)}
              >
                <Badge
                  badgeContent={propertyCountByCategory[option] || 0}
                  color="success"
                  max={Infinity}
                  sx={{ "& .MuiBadge-badge": { top: 0, right: 0 } }}
                >
                  {iconMapping[option]}
                </Badge>
                <Typography
                  variant="body2"
                  sx={{ display: { xs: "none", sm: "block" } }}
                >
                  {option}
                </Typography>
              </IconButton>
            ))}
          </Box>
          {showRightArrow && (
            <Box sx={{ display: { xs: "none", md: "block" }, pr: 2 }}>
              <FontAwesomeIcon
                size="xl"
                onClick={() => scroll("right")}
                icon={faCircleArrowRight}
                className="arrow"
              />
            </Box>
          )}
          {/* Botones adicionales que aparecen al seleccionar un botón */}
          <>
            <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
              <Button
                variant="outlined"
                startIcon={
                  <FilterList
                    sx={{
                      color: "green",
                      pl: { xs: "12px", sm: "0px" },
                      fontSize: { xs: "20px", sm: "24px" },
                      margin: { xs: "auto", sm: 0 },
                    }}
                  />
                }
                sx={{
                  textTransform: "none",
                  height: { xs: "40px", sm: "50px" },
                  minWidth: { xs: "40px", sm: "auto" },
                  border: "1px solid lightgray",
                  borderRadius: "8px",
                  paddingX: { xs: 0, sm: 2 },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    borderColor: "black",
                  },
                }}
                onClick={handleFilterModalOpen}
              >
                <Typography
                  variant="caption"
                  color="black"
                  sx={{
                    fontWeight: "600",
                    display: { xs: "none", sm: "block" },
                  }}
                >
                  Filtros
                </Typography>
              </Button>
            </Box>
          </>
        </Box>
      )}

      {/* Mostrar el AuthModal si está abierto */}
      {openAuthModal && (
        <AuthModal open={openAuthModal} onClose={handleAuthModalClose} />
      )}

      {/* Mostrar el WelcomeBackModal si está abierto */}
      {openWelcomeBackModal && (
        <WelcomeBackModal
          open={openWelcomeBackModal}
          onClose={handleWelcomeBackModalClose}
          onSignIn={handleAuthModalOpen}
        />
      )}

      <BrokerProfileRequiredModal
        open={openBrokerProfileRequiredModal}
        onClose={handleBrokerProfileRequiredModalClose}
      />

      {/* Mostrar el ConvertModal si está abierto */}
      {openConvertModal && (
        <PriceConversionModal
          open={openConvertModal}
          onClose={handleConvertModalClose}
        />
      )}

      {openFilterModal && (
        <PropertyFilterModal
          open={openFilterModal}
          onClose={handleFilterModalClose}
        />
      )}
      <CompaniesModal
        open={openRealEstateModal}
        onClose={handleCloseRealEstateModal}
      />
    </AppBar>
  );
};



export default Header;
